import groupBy from 'lodash-es/groupBy';
import sortBy from 'lodash-es/sortBy';
import Link from 'next/link';

import { Medal } from '@/components/Medal';
import {
  ProfilePicture,
  profilePictureFragment,
} from '@/components/ProfilePicture';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { getProfileUrl } from '@/utils';
import { graphql, readFragment, type FragmentOf } from '@/utils/graphql';

export const matchdayLeaderboardFragment = graphql(
  `
    fragment matchdayLeaderboardFields on matchdays {
      leaderboard(sort: "position") {
        id
        position
        freestyler {
          id
          name
          username
          ...profilePictureFields
        }
      }
    }
  `,
  [profilePictureFragment],
);

export function MatchdayLeaderboard({
  matchday: _matchday,
}: {
  matchday: FragmentOf<typeof matchdayLeaderboardFragment>;
}) {
  const matchday = readFragment(matchdayLeaderboardFragment, _matchday);

  if (!matchday.leaderboard?.length) {
    return null;
  }

  const groupedLeaderboard = groupBy(matchday.leaderboard, 'position');

  return (
    <ol className="flex flex-row items-center gap-1 pl-4 py-2">
      {Object.keys(groupedLeaderboard).map((position) => (
        <li key={position}>
          {sortBy(
            groupedLeaderboard[position],
            (entry) => entry?.freestyler?.name,
          ).map(
            (entry) =>
              entry && (
                <div key={entry.id}>
                  <TooltipProvider delayDuration={0}>
                    <Tooltip>
                      {/* TODO: Re-enable asChild */}
                      <TooltipTrigger asChild={false}>
                        <div className="relative">
                          <Link
                            href={getProfileUrl(entry.freestyler!)}
                            prefetch={false}
                          >
                            <ProfilePicture
                              profile={entry.freestyler!}
                              options={{ width: 32, height: 32 }}
                            />
                          </Link>
                          <Medal
                            position={entry.position}
                            className="absolute z-10 top-4 left-5"
                          />
                        </div>
                      </TooltipTrigger>
                      <TooltipContent>
                        <span>{`${entry.position}.º ${entry.freestyler!.name}`}</span>
                      </TooltipContent>
                    </Tooltip>
                  </TooltipProvider>
                </div>
              ),
          )}
        </li>
      ))}
    </ol>
  );
}
